import styled from 'styled-components';

export const Container = styled.div`
    background-color: var(--theme-color-secondary);
    border-radius: 1rem;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    
    @media only screen and (max-width: 575px) {
        padding: 16px 12px;
        gap: 8px;
    }
`;
export const TopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`; 

export const IconBox = styled.div`
    background: ${props => {
        switch (props.$variant) {
            case 'success':
                return 'var(--color-success)';
            case 'pending':
                return 'var(--color-warning)';
            default:
                return 'var(--theme-color-primary)';
        }
    }};
    border-radius: 10px;
    width: 35px;
    height: 35px; 
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        width: 20px;
        height: 20px;
        color: var(--theme-color-white);
    }
`;

export const Title = styled.div`
    color: var(--text-color-primary);
    font-size: 16px;
    font-weight: 500;
    flex: 1;
    word-break: break-word;

    @media only screen and (max-width: 600px) {
        font-size: 16px;
    }
`;

export const ValueRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5px;

    p {
        margin: 0;
    }
`;

export const ThirdRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5px;

    p {
        margin: 0;
    }
`;

export const ThirdRowValue = styled.p`
    color: ${props => {
        switch (props.$variant) {
            case 'success':
                return 'var(--color-success)';
            case 'pending':
                return 'var(--color-warning)';
            default:
                return 'var(--color-success)';
        }
    }};
    text-align: right;
`;